import styled from 'styled-components'
import {media} from "@/styles/Qtheme.ts";
import {MobileCalVW, TabletCalVW} from "@utils/CalVW.tsx";


export const List = styled.div`
    width: 589px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    height: 73px;
    padding-left: 34px;
    font-family: "Pretendard", sans-serif;


    @media ${media.desktop} {
        width: ${TabletCalVW(900)};
        justify-content: space-between;
        padding-right: 34px;
    }

    @media ${media.mobile} {
        padding: ${MobileCalVW(12)} ${MobileCalVW(20)};
        width: 100%;
    }

    transition: all 0.3s;

    & * {
        transition: all 0.3s;
    }

    &:hover {
        background-color: ${({theme}) => theme.subMenuHover};

        * {
                /* color: ${({theme}) => theme.primary}; */
        }

        img {
                /* border: 1px solid ${({theme}) => theme.primary}; */
        }
    }
`

export const NameContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 20%;


    @media ${media.desktop} {
        gap: 12px;

        img {
            width: 30px;
        }
    }

    @media ${media.mobile} {
    }

    & img {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background-color: #efefef;
        border: 1px solid #efefef;


        @media ${media.mobile} {
            width: ${MobileCalVW(20)};
            height: ${MobileCalVW(20)};
        }
    }

`

export const Icon = styled.div`
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background-color: gray;


    @media ${media.mobile} {
        width: ${MobileCalVW(35)};
        height: ${MobileCalVW(35)};
    }
`

export const Name = styled.p`
    font-size: 16px;
    font-weight: 600;
    color: ${({theme}) => theme.text};

    @media ${media.mobile} {
        font-size: ${MobileCalVW(14)};
    }
`

export const FullName = styled.p`
    font-size: 16px;
    font-weight: 400;
    color: ${({theme}) => theme.moreText};


    @media ${media.desktop} {
        font-size: ${MobileCalVW(13)};
    }
`

export const Price = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: ${({theme}) => theme.text};
    width: 25%;
    text-align: end;


    @media ${media.mobile} {
        width: 35%;
        font-size: ${MobileCalVW(13)};
    }
`

interface IndeProps {
  minus: boolean
}

export const Inde = styled.p<IndeProps>`
    font-size: 16px;
    font-weight: 400;
    color: ${({minus}) => (minus ? '#F71053' : '#37A16A')};
    width: 10%;
    margin-left: 7%;
    text-align: end;


    @media ${media.mobile} {
        width: auto;
        margin-left: 0;
        font-size: ${MobileCalVW(13)};
    }
`

export const TradeButton = styled.button`
    font-family: Arial, sans-serif;
    width: 73px;
    height: 30px;
    border-radius: 100px;
    font-size: 14px;
    font-weight: 400;
    color: ${({theme}) => theme.text};
    background-color: ${({theme}) => theme.p2pBorder};
    margin-left: 5%;


    @media ${media.desktop} {
        margin-left: 5%;
    }

    @media ${media.mobile} {
        display: none;
    }
`
